var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextmax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4066 9.31036V15.6904C10.4066 16.997 11.8266 17.817 12.9599 17.1637L15.7266 15.5704L18.4933 13.9704C19.6266 13.317 19.6266 11.6837 18.4933 11.0304L15.7266 9.43036L12.9599 7.83703C11.8266 7.18369 10.4066 7.99703 10.4066 9.31036Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90662 17.1199C7.63328 17.1199 7.40662 16.8932 7.40662 16.6199V8.37988C7.40662 8.10655 7.63328 7.87988 7.90662 7.87988C8.17995 7.87988 8.40662 8.10655 8.40662 8.37988V16.6199C8.40662 16.8932 8.18662 17.1199 7.90662 17.1199Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextmax);
export default __webpack_public_path__ + "static/media/nextmax.9f1e31d8e8a5e194824c359fd0b1ec98.svg";
export { ForwardRef as ReactComponent };